import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userSubject = new BehaviorSubject<any>(null);
  user$ = this.userSubject.asObservable(); // Observable to subscribe in Header

  constructor(private router: Router) {
    this.loadUser();
  }

  //  Load user data when service initializes
  loadUser() {
    const userData = localStorage.getItem('user');
    if (userData) {
      this.userSubject.next(JSON.parse(userData)); // Set user data in BehaviorSubject
    }
  }

  //  Update user data on login
  setUser(user: any) {
    localStorage.setItem('user', JSON.stringify(user));
    this.userSubject.next(user); // Notify all subscribers
  }

  // Check if the user is authenticated
  isAuthenticated(): boolean {
    const token = localStorage.getItem('userToken');
    const user = localStorage.getItem('user');
    const isAuth = !!token && !!user;
    console.log('Authentication check:', isAuth);
    return isAuth;
  }

    // ✅ Logout function
    logout(navigate: boolean = true) {
      console.log('Logging out user');
      localStorage.removeItem('user');
      localStorage.removeItem('userToken');
      this.userSubject.next(null); // Reset user data
      
      // Navigate to the login page if requested
      if (navigate) {
        this.router.navigate(['/auth/sign-in']);
      }
    }
}
